if (!window.minoIconStackInitialized) {
  window.minoIconStackInitialized = true;

  class MinoIconStack {
    constructor() {
      this.mq = window.matchMedia('(min-width: 768px)');
      if (!this.mq.matches) return;

      this.sections = Array.from(document.querySelectorAll('.section-key-features'));
      if (this.sections.length === 0) return;

      // Only sections that have an icon to show in the stack
      this.iconEntries = this.sections
        .map((section) => {
          const el = section.querySelector('scrolling-image-list[data-section-icon]');
          return el ? { section, iconUrl: el.dataset.sectionIcon } : null;
        })
        .filter(Boolean);

      if (this.iconEntries.length === 0) return;

      this.overlay = null;
      this.itemEls = [];
      this.isVisible = false;
      this.activeCount = 0;
      this.stackStart = null;

      this.createOverlay();
      this.positionItems();
      this.bind();
    }

    createOverlay() {
      this.overlay = document.createElement('div');
      this.overlay.className = 'mino-icon-stack';
      this.overlay.setAttribute('aria-hidden', 'true');

      this.itemEls = this.iconEntries.map(({ iconUrl }) => {
        const item = document.createElement('div');
        item.className = 'mino-icon-stack__item';

        if (iconUrl) {
          const img = document.createElement('img');
          img.src = iconUrl;
          img.alt = '';
          item.appendChild(img);
        }

        this.overlay.appendChild(item);
        return item;
      });

      document.body.appendChild(this.overlay);
    }

    getHeading(section) {
      const s = section || this.sections[0];
      return s ? s.querySelector('.scrolling-image-list__content-area .subheading') : null;
    }

    getCurrentSection() {
      const scrollMid = window.scrollY + window.innerHeight / 2;
      for (const section of this.sections) {
        const images = section.querySelectorAll('.scrolling-image-list__image');
        if (images.length === 0) continue;
        const first = images[0];
        const last = images[images.length - 1];
        const firstMid = first.getBoundingClientRect().top + window.scrollY + first.offsetHeight / 2;
        const lastMid = last.getBoundingClientRect().top + window.scrollY + last.offsetHeight / 2;
        if (scrollMid >= firstMid && scrollMid <= lastMid) return section;
      }
      return null;
    }

    positionItems(stackStart) {
      const ICON_SIZE = 60;
      const ICON_GAP = 10;
      const STRIDE = ICON_SIZE + ICON_GAP;

      if (stackStart !== undefined) {
        this.stackStart = stackStart;
      } else {
        const section = this.sections[0];
        const featureText = section ? section.querySelector('.feature-text-paired') : null;
        const heading = this.getHeading();

        if (featureText && heading) {
          const ftHeight = featureText.getBoundingClientRect().height;
          const headingOffsetInContainer =
            heading.getBoundingClientRect().top - featureText.getBoundingClientRect().top;
          this.stackStart = window.innerHeight / 2 - ftHeight / 2 + headingOffsetInContainer;
        } else {
          this.stackStart = window.innerHeight * 0.25;
        }
      }

      this.itemEls.forEach((item, i) => {
        item.style.top = `${this.stackStart + i * STRIDE}px`;
      });

      this.updateLeftPosition();
    }

    updateLeftPosition(section) {
      const target = section || this.sections[0];
      const ref = target
        ? target.querySelector('.flexible-layout .column--half')
        : null;
      if (!ref) return;

      const bcr = ref.getBoundingClientRect();
      this.overlay.style.left = `${bcr.left + 30}px`;
    }

    update() {
      if (!this.mq.matches) return;

      const scrollMid = window.scrollY + window.innerHeight / 2;

      const firstSection = this.sections[0];
      const lastSection = this.sections[this.sections.length - 1];
      const firstTop = firstSection.getBoundingClientRect().top + window.scrollY;
      const lastBottom = lastSection.getBoundingClientRect().bottom + window.scrollY;

      const inRange = scrollMid >= firstTop && scrollMid <= lastBottom;

      if (inRange !== this.isVisible) {
        this.isVisible = inRange;
        this.overlay.classList.toggle('mino-icon-stack--visible', inRange);
      }

      if (inRange) {
        const currentSection = this.getCurrentSection();
        this.updateLeftPosition(currentSection);

        if (currentSection) {
          const heading = this.getHeading(currentSection);
          if (heading) {
            const headingTop = heading.getBoundingClientRect().top;
            if (headingTop !== this.stackStart) {
              this.positionItems(headingTop);
            }
          }
        }

        // Count how many icon-stack sections have been scrolled past
        let count = 0;
        for (const { section } of this.iconEntries) {
          const sectionTop = section.getBoundingClientRect().top + window.scrollY;
          if (scrollMid >= sectionTop) count++;
        }

        if (count !== this.activeCount) {
          this.activeCount = count;
          this.itemEls.forEach((item, i) => {
            item.classList.toggle('mino-icon-stack__item--visible', i < count);
          });
        }
      }
    }

    bind() {
      let rafId = null;
      const onScroll = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          this.update();
          rafId = null;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        this.positionItems();
        this.update();
      });

      this.mq.addEventListener('change', (e) => {
        if (!e.matches && this.overlay) {
          this.overlay.classList.remove('mino-icon-stack--visible');
        }
      });

      this.update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MinoIconStack());
  } else {
    new MinoIconStack();
  }
}
